module.exports = __webpack_public_path__ + "img/nails.d45f49c6.jpg";